<template>
  <div class="activity-supervisor-page" :class = "{'clear-header':isWechatBrowser}">
    <my-header v-if="!isWechatBrowser" class="top-title" :title="activityTitle" :showBack="true"></my-header>
    <div class="activity-part">
      <div class="activity-desc">10月21日水木带您一起看工地</div>
      <div class="activity-content">
        <div style="margin-bottom: 0.25rem">
          <img style="width: 0.26rem;height: 0.2rem;margin-right: 0.14rem" src="../../assets/icon/icon-activity-point.png">活动时间：2018-10-21 周日
        </div>
        <div>
          <img style="width: 0.26rem;height: 0.2rem;margin-right: 0.14rem" src="../../assets/icon/icon-activity-point.png">活动简介："两周一次"的看工地活动开始了由工程专家带大家参观施工现场，依次参观水电改造、泥木工程、油漆工程，学习装修常识，避免装修隐患。
        </div>
      </div>
      <img class="activity-background" src="../../assets/icon/icon-activity-foreman-header.jpg">
    </div>
    <div class="supervisor-list" style="padding-top: 0.4rem">
      <div class="supervisor-part-border" v-for="supervisor in activitySupervisorList">
        <div class="supervisor-info-part">
          <img class="avatar" :src="imgUrl+supervisor.supervisorAvatar">
          <div class="detail">
            <div class="supervisor-name">工长:{{supervisor.supervisorName}}</div>
            <div class="supervisor-deposit">订金:<span style="color: #FF7544;font-size: 0.34rem">{{supervisor.deposit}}元</span></div>
            <div v-if="supervisor.supervisorIntro">简介：{{supervisor.supervisorIntro}}</div>
            <div class="appointment-btn" @click="openGangmasterReservation(supervisor)">立即预约</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import activityService from '../../service/activity/ActivityService'
  import activitySupervisorService from '../../service/activity/ActivitySupervisorService'
  import supervisorService from '../../service/SupervisorService'
  import {imgUrl,shareIcon} from "../../config";

  export default {
    name: 'ActivityDetail',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        activityTitle:'',
        imgUrl: imgUrl,
        activityId:'',
        activityDetail:{},
        activitySupervisorList:[]
      }
    },
    created(){
      this.activityTitle = this.$route.query.activityTitle || '活动工长';
      this.activityId = this.$route.query.activityId;
    },
    beforeMount () {
      document.title = this.activityTitle;
      this.isWechatBrowser = this.$route.meta.isWechatBrowser;

      this.loadActivityDetail();
      this.loadActivitySupervisorList();
    },
    methods: {
      async loadActivityDetail(){
        let {code,msg,data} = await activityService.detail(this.activityId);
        if(code == '0'){
          this.activityDetail = data;
        }else {
          Toast(msg);
        }
      },
      async loadActivitySupervisorList(){
        let {code,msg,data} = await activitySupervisorService.list(this.activityId);
        if(code == '0'){
          this.activitySupervisorList = [...this.activitySupervisorList , ...data.activitySupervisorList];
          for (let supervisor of this.activitySupervisorList){
            if(supervisor.supervisorIntro && supervisor.supervisorIntro.length>28){
              supervisor.supervisorIntro = supervisor.supervisorIntro.substring(0,28) + '...'
            }
          }
        }else {
          Toast(msg);
        }
      },
      async openGangmasterReservation(activityGangmaster){
        let foremanRes = await supervisorService.getSupervisorDetail(activityGangmaster.supervisorId);
        if(foremanRes.code != 0){
          Toast('获取工长信息失败，请稍后重试');
        }
        let foreman = foremanRes.data;
        if(foreman.appointmentSwitch != '1'){
          Toast('该工长暂时不接受预约!');
        }else if(foreman.appointmentSwitch == '1' && foreman.spares == 0){
          Toast('该工长预约已满!');
        }else {
          //TODO
          if(!!this.global.isMiniProgrm ){
            wx.miniProgram.navigateTo({url: `/pages/gangmaster/reservation?id=${foreman.id}&companyId=${foreman.companyId}&deposit=${activityGangmaster.deposit}&supervisorName=${foreman.name}`});
          }else {
            this.$router.push({name:'GangmasterReservation',query:{id:foreman.id,companyId:foreman.companyId,supervisorName:foreman.name,deposit:activityGangmaster.deposit}});

          }
        }
      },
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .activity-supervisor-page {
    font-size: 0.34rem;
    text-align: left;
    background-color: #f3f8fc;

    .activity-part{
      color: white;
      position: relative;
      .activity-desc{
        position: absolute;
        left: 32%;
        top: 1.65rem;
        transform: translate(-25%, -25%);
      }
      .activity-content{
        position: absolute;
        left: 25%;
        top: 2.2rem;
        transform: translate(-20%, 50%);
      }
      .activity-background{
        width: 100%;
        height: 9.45rem;
        display: block
      }
    }
    .supervisor-list{
      background-color: #132962;
      padding-bottom: 0.8rem;
      font-size: 0.28rem;
      color: #132962;
      .supervisor-part-border{
        width: 6.94rem;
        height: 4.14rem;
        margin: 0 auto 0.26rem;
        border-radius: 0.2rem;
        border: solid 1px #FFD703
      }
      .supervisor-info-part{
        width: 6.52rem;
        height: 3.6rem;
        margin: 0.3rem auto;
        background-color: white;
        border-radius: 0.2rem;
        display: flex;
        .avatar{
          width: 2.72rem;
          height: 3.5rem;
          border-top-left-radius: 0.2rem;
          border-bottom-left-radius: 0.2rem;
        }
        .detail{
          width: 3.6rem;
          margin-left: 0.26rem;
          position: relative;
          .supervisor-name{
            margin-top: 0.26rem;
            margin-bottom: 0.08rem
          }
          .supervisor-deposit{
            margin-bottom: 0.08rem
          }
          .appointment-btn{
            position: absolute;
            right: 0.3rem;
            bottom: 0.26rem;
            width: 1.7rem;
            height: 0.6rem;
            line-height: 0.62rem;
            font-size: 0.28rem;
            color: white;
            background-color: #1D8AE7;
            text-align: center;
            border-radius: 0.62rem;
          }
        }
      }
    }
  }
</style>
